<template>
    <div class="navbar-container">
        <img src="@/assets/IFAS-White.png" alt="Logo" class="navbar-logo" @click="sendPageName('map')"/>
        <div>
            <font-awesome-icon icon="question-circle"/>
            <span class="project-title" @click="sendPageName('about')">About the project</span>
            <font-awesome-icon icon="envelope" class="envelope-icon"/>
            <span class="feedback-title">Give us feedback!</span>
        </div>
    </div>
</template>

<script setup>

import { defineEmits } from 'vue';

const emit = defineEmits(['getPageName']);

const sendPageName = (name) => {
    emit('getPageName', name);
}


</script>


<style scoped>
.navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center; /* Vertically align items */
    background-color: #14213d;
    padding: 10px;
    color: white; /* Change text color for visibility */
}

/* Style the image */
.navbar-logo {
    width: 150px; /* Set the size of the image */
    height: auto; /* Maintain aspect ratio */
    margin-right: 20px; /* Space between the image and the text */
    cursor: pointer;
}

.project-title {
    padding-left: 5px;
    font-family: courier;
    cursor: pointer;
}

.envelope-icon {
    padding-left: 30px;
}

.feedback-title {
    padding-right: 30px;
    padding-left: 5px;
    font-family: courier;
    cursor: pointer;
}

</style>

